import {gsap} from "gsap";
import {Draggable} from "gsap/Draggable";
import InertiaPlugin from "gsap/InertiaPlugin";
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(Draggable, InertiaPlugin, ScrollToPlugin);

const RentalTabs = {
    current: null,

    init() {
        this.el = $('[module="rental"][view="tabs"]');
        if (!this.el.length) return;

        this.dragger = this.el.find('.dragger');
        this.touch = matchMedia('(hover: none)').matches;
        this.tabs = this.el.find('a.tab');

        this.setCurrent(window.location.pathname);
        this.bind();
        this.bindDrag();
        this.animate();
    },

    animate() {
        if (!this.el.length) return;
        gsap.to(this.tabs.not('.disabled'), {opacity: 1, stagger: 0.15, duration:1})
        gsap.to(this.tabs.filter('.disabled'), {opacity: 0.4, stagger: 0.15, duration:1})
    },

    show() {
        if (!this.el.length) return;
        gsap.set(this.el.find('a.tab').not('.disabled'), {opacity: 1})
        gsap.set(this.el.find('a.tab').filter('.disabled'), {opacity: 0.4})
    },

    setCurrent(url) {
        this.current = this.el.find('a.tab[href="' + url + '"]');

        if (this.current.length === 0) {
            this.current = this.el.find('a.tab:first-child');
        }

        setTimeout(() => {
            this.scrollToCenter();
        }, 500)
    },

    bind() {
        if (!this.el.length) return;
        this.el.find('a.tab').on('click', (evt) => this.onClick(evt));
    },

    bindDrag() {
        if (this.touch) return;

        Draggable.create(this.dragger, {
            type: "scrollLeft",
            lockAxis: true,
            inertia: true,
            edgeResistance: 0.9,
            allowContextMenu: true,
            cursor:"default",
            activeCursor:"grabbing",
        });
    },

    onClick(evt) {
        evt.preventDefault();
        const tab = $(event.currentTarget);

        if (tab.is(".active")) {
            return;
        }

        let url = tab.attr('href');
        const hash = rentalHash ? `?hash=${rentalHash}` : ''
        const direction = tab.attr('order') > this.current.attr('order') ? 1 : -1
        this.current = tab;

        history.pushState({url: url, direction:direction}, '', url + hash)
        Rental.load(url, null, direction);
    },

    scrollToCenter() {
        if (this.current.length === 0) {
            return;
        }

        const left = this.current.position().left;
        const tabWidth = this.current.outerWidth();
        const gap = 16;
        const shift = (window.innerWidth - tabWidth) / 2 - (gap / 2);
        const scroll = left - shift;

        gsap.to(this.dragger, {scrollLeft: scroll})
    },

    resize() {
        if (!this.el.length) return;
        this.scrollToCenter();
    }
}

export default RentalTabs;